module.exports = __webpack_public_path__ + "static/yoga-5c7a688d2272d19eaa04d6fd8b28d362.png";